/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
    document.addEventListener("DOMContentLoaded", (event) => {
        var links = document.links;
        for (let i = 0, linksLength = links.length; i < linksLength; i++) {
            if (links[i].hostname !== window.location.hostname) {
                links[i].target = "_blank";
                links[i].rel = "noreferrer noopener";
            }
        }


        //Avatar for blog posts
        const avatar = document.querySelector('.article-info__author-avatar');
        if (!avatar) return;
        const newImageUrl = avatar.dataset.author;
        if (!newImageUrl) return;
        const newImage = new Image();
        newImage.onload = function () {
            avatar.src = newImageUrl;
        };
        newImage.onerror = function () {
            // image doesn't exist → нічого не робимо
            console.log('Author image not found');
        };
        newImage.src = newImageUrl;
    });






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

document.addEventListener('click', function(event) {
  const button = event.target.closest('.boost-card-add-to-cart[data-add-to-cart]');

  if (!button) return;

  const form = button.closest('form');
  const errorContainer = form?.querySelector('[data-cart-errors-container]');

  if (!form || button.disabled) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  button.classList.add('is-loading');
  button.disabled = true;

  if (errorContainer) {
    errorContainer.textContent = '';
    errorContainer.classList.remove('is-expanded');
  }

  fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json'
    },
    body: new FormData(form)
  })
    .then(function(response) {
      return response.json();
    })
    .then(function(response) {
      if (response.status) {
        throw response;
      }

      const cart = document.querySelector('cart-element');

      if (cart && typeof cart.getCart === 'function') {
        cart.button = button;
        cart.getCart();
      } else {
        window.location.href = window.theme?.routes?.cart_url || '/cart';
      }
    })
    .catch(function(error) {
      const message = error?.description || error?.message || 'Unable to add this item to the cart.';

      button.classList.remove('is-loading');
      button.disabled = false;

      if (errorContainer) {
        errorContainer.textContent = message;
        errorContainer.classList.add('is-expanded');
      }
    });
}, true);


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("img").forEach(function (img) {
    const alt = img.getAttribute("alt");

    // If alt is missing or empty
    if (!alt || alt.trim() === "") {
      const src = img.getAttribute("src");
      if (!src) return;

      // Extract filename from URL
      let filename = src.split("/").pop().split("?")[0];

      // Remove file extension
      filename = filename.replace(/\.[^/.]+$/, "");

      // Make it more readable: replace dashes/underscores with spaces
      filename = filename.replace(/[-_]+/g, " ").trim();

      if (filename) {
        img.setAttribute("alt", filename);
      }
    }
  });

      const observer = new MutationObserver(() => {
        const img = document.querySelector('img[src*="bat.bing.com"]');

        if (img) {
            img.setAttribute('alt', 'tracker')
            observer.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

function checkCartMinimum() {
  const drawer = document.getElementById('cart-drawer');
  const notice = document.getElementById('cart-minimum-notice');
  const priceElement = document.querySelector('[data-cart-total-price]');

  if (drawer && notice && priceElement) {
    const isDrawerVisible = drawer.classList.contains('is-open');
    const currentTotal = parseFloat(priceElement.textContent.replace(/[^\d.]/g, ''));

    if (isDrawerVisible && currentTotal > 0 && currentTotal < 300) {
      notice.style.display = 'block';
    } else {
      notice.style.display = 'none';
    }
  }
}

function setAnchorTarget() {
  const links = document.querySelectorAll('a');
  links.forEach(link => {
    let href = link.getAttribute('href');
    if (href && href.includes('anchor')) {
      let id = href.split('#')[1];
      let anchorClass = '.' + id;
      let anchorElement = document.querySelector(anchorClass);
      if (anchorElement) {
        let section = anchorElement.closest('section');
        link.addEventListener('click', function (e) {
          e.preventDefault();
          section.scrollIntoView({ behavior: 'smooth' });
        });
      }
    }
  });
}

const cartNoticeObserver = new MutationObserver(checkCartMinimum);

cartNoticeObserver.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['class', 'style']
});

document.addEventListener('DOMContentLoaded', checkCartMinimum);
window.addEventListener('load', checkCartMinimum);


function scrollToConfiguredTarget(trigger) {
  const targetSelector = trigger.dataset.scrollTarget;
  let target;

  try {
    target = targetSelector ? document.querySelector(targetSelector) : null;
  } catch (error) {
    return;
  }

  if (!target) return false;

  const offsetValue = window.matchMedia('(max-width: 767px)').matches
    ? trigger.dataset.scrollOffsetMobile
    : trigger.dataset.scrollOffset;
  const offset = Number.parseInt(offsetValue, 10) || 0;
  const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const originalScrollMarginTop = target.style.scrollMarginTop;

  target.style.scrollMarginTop = `${-offset}px`;
  target.scrollIntoView({ behavior: behavior, block: 'start', inline: 'nearest' });

  window.setTimeout(function() {
    target.style.scrollMarginTop = originalScrollMarginTop;
  }, behavior === 'smooth' ? 1000 : 0);

  return true;
}

document.addEventListener('click', function(event) {
  const trigger = event.target.closest('[data-smooth-scroll]');

  if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  scrollToConfiguredTarget(trigger);
}, true);

document.addEventListener('keydown', function(event) {
  if (event.key !== 'Enter' && event.key !== ' ') return;

  const trigger = event.target.closest('[data-smooth-scroll]');
  if (!trigger) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  scrollToConfiguredTarget(trigger);
}, true);
(function() {
  const selector = '.boost-sd__instant-search-results--two-column.boost-sd__instant-search-results--product-type-grid .boost-sd__suggestion-queries-item-img';
  const desktopSizes = '(min-width: 991px) 220px, 50vw';

  function getImages(root) {
    if (!root) return [];
    if (root.matches && root.matches(selector)) return [root];
    if (root.querySelectorAll) return Array.from(root.querySelectorAll(selector));
    return [];
  }

  function upgradeImageSrc(img) {
    const src = img.getAttribute('src');
    if (!src) return;

    try {
      const url = new URL(src, window.location.origin);
      const width = Number(url.searchParams.get('width'));

      if (url.hostname.includes('cdn.shopify.com') && width > 0 && width < 500) {
        url.searchParams.set('width', '500');
        img.setAttribute('src', url.toString());
      }
    } catch (error) {
      // Leave non-standard image URLs alone.
    }
  }

  function upgradeBoostInstantSearchImages(root) {
    getImages(root).forEach(function(img) {
      if (img.dataset.boostInstantSearchImageUpgraded === 'true') return;

      img.setAttribute('sizes', desktopSizes);

      const srcset = img.getAttribute('srcset');
      if (srcset) {
        img.setAttribute('srcset', '');
        img.setAttribute('srcset', srcset);
      }

      upgradeImageSrc(img);
      img.dataset.boostInstantSearchImageUpgraded = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    upgradeBoostInstantSearchImages(document);

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          upgradeBoostInstantSearchImages(node);
        });
      });
    });

    observer.observe(document.body, {childList: true, subtree: true});
  });
})();

(function() {
  function updateClearButton(input) {
    const inputHolder = input.closest('.search-form__input-holder');
    const clearButton = inputHolder && inputHolder.querySelector('[data-search-clear]');
    if (clearButton) clearButton.hidden = input.value.length === 0;
  }

  function updateViewAllCount(predictiveSearch) {
    const count = predictiveSearch.dataset.searchResultsCount;
    if (!count) return;

    predictiveSearch.querySelectorAll('[data-predictive-search-view-all]').forEach(function(link) {
      const label = link.dataset.labelTemplate.replace('[count]', count);
      const labelElement = link.querySelector('[data-predictive-search-view-all-label]');

      if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
      if (labelElement && labelElement.textContent !== label) labelElement.textContent = label;
    });
  }

  function requestFullSearchCount(input) {
    const searchTerm = input.value.trim();
    const predictiveSearch = input.closest('predictive-search');
    if (!predictiveSearch) return;

    if (!searchTerm) {
      delete predictiveSearch.dataset.searchResultsCount;
      return;
    }

    clearTimeout(input.fullSearchCountTimer);
    input.fullSearchCountTimer = setTimeout(function() {
      const boostShopDomain = window.boostWidgetIntegration?.config?.shop?.domain;
      const url = boostShopDomain
        ? new URL('https://services.mybcapps.com/bc-sf-filter/search')
        : new URL(window.theme.routes.searchUrl, window.location.origin);

      url.searchParams.set('q', searchTerm);
      if (boostShopDomain) {
        url.searchParams.set('shop', boostShopDomain);
        url.searchParams.set('limit', '1');
      } else {
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('section_id', 'api-search-count');
      }

      fetch(url.toString())
        .then(function(response) {
          if (!response.ok) throw new Error(response.status);
          return boostShopDomain ? response.json() : response.text();
        })
        .then(function(response) {
          if (input.value.trim() !== searchTerm) return;

          const count = boostShopDomain
            ? response.total_product
            : new DOMParser().parseFromString(response, 'text/html').querySelector('[data-search-results-count]')?.textContent.trim();
          if (count === undefined || count === null || count === '') return;

          predictiveSearch.dataset.searchResultsCount = count;
          updateViewAllCount(predictiveSearch);
        })
        .catch(function() {
          // Keep the predictive-search count as the fallback if the count request fails.
        });
    }, 350);
  }

  function ensureHeaderPredictiveSearch(input) {
    const predictiveSearch = input.closest('search-popdown[data-popdown-in-header] predictive-search');
    if (!predictiveSearch || !input.value.trim()) return;

    clearTimeout(input.predictiveSearchFallbackTimer);
    input.predictiveSearchFallbackTimer = setTimeout(function() {
      if (predictiveSearch.hasAttribute('loading') || predictiveSearch.hasAttribute('results')) return;

      // Boost Search can intercept input events on the search-results template.
      // Start the theme's native predictive search only when its own handler did not.
      if (typeof predictiveSearch.onChange === 'function') predictiveSearch.onChange();
    }, 400);
  }

  function closePredictiveSearchOnOutsidePointer(event) {
    document.querySelectorAll('predictive-search[open="true"]').forEach(function(predictiveSearch) {
      if (predictiveSearch.contains(event.target)) return;

      if (typeof predictiveSearch.close === 'function') predictiveSearch.close();
      predictiveSearch.removeAttribute('open');
      predictiveSearch.removeAttribute('loading');

      const input = predictiveSearch.querySelector('input[type="search"]');
      if (input) {
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
      }

      const searchPopdown = predictiveSearch.closest('search-popdown[data-popdown-in-header]');
      if (searchPopdown && typeof searchPopdown.close === 'function') searchPopdown.close();
    });
  }

  document.addEventListener('input', function(event) {
    if (!event.target.matches('input[type="search"]')) return;

    updateClearButton(event.target);
    requestFullSearchCount(event.target);
  });

  document.addEventListener('input', function(event) {
    if (!event.target.matches('input[type="search"]')) return;

    ensureHeaderPredictiveSearch(event.target);
  }, true);

  document.addEventListener('focusin', function(event) {
    if (!event.target.matches('input[type="search"]')) return;

    ensureHeaderPredictiveSearch(event.target);
  }, true);

  document.addEventListener('click', function(event) {
    const clearButton = event.target.closest('[data-search-clear]');
    if (!clearButton) return;

    const search = clearButton.closest('search-popdown');
    const input = search && search.querySelector('input[type="search"]');
    if (!input) return;

    event.preventDefault();
    input.value = '';
    input.dispatchEvent(new Event('input', {bubbles: true}));
    input.focus();
  });

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.search-form__input-holder input[type="search"]').forEach(updateClearButton);

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          const predictiveSearch = node.parentElement && node.parentElement.closest('predictive-search');
          if (predictiveSearch) updateViewAllCount(predictiveSearch);
        });
      });
    });

    observer.observe(document.body, {childList: true, subtree: true});
  });

  document.addEventListener('pointerdown', closePredictiveSearchOnOutsidePointer, true);
})();

(function() {
  const paginationSelector = '.boost-sd__pagination button';
  const activePageSelector = '.boost-sd__pagination-number--active';
  const toolbarSelector = '.boost-sd__toolbar-container';

  function getRequestedPage(button) {
    const label = button.getAttribute('aria-label') || '';
    const pageMatch = label.match(/^Go to Page (\d+)$/);

    if (pageMatch) return Number(pageMatch[1]);

    const currentPage = document.querySelector(activePageSelector);
    const currentPageNumber = currentPage ? Number(currentPage.textContent.trim()) : 0;

    if (!currentPageNumber) return 0;
    if (button.classList.contains('boost-sd__pagination-button--next')) return currentPageNumber + 1;
    if (button.classList.contains('boost-sd__pagination-button--prev')) return currentPageNumber - 1;

    return 0;
  }

  function scrollToCollectionGrid() {
    const toolbar = document.querySelector(toolbarSelector);
    if (!toolbar) return;

    const stickyHeader = document.querySelector('[data-site-header][data-position="fixed"]');
    const headerOffset = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
    const top = toolbar.getBoundingClientRect().top + window.scrollY - headerOffset - 16;

    window.scrollTo({ top: Math.max(0, top), left: 0, behavior: 'auto' });
  }

  document.addEventListener('click', function(event) {
    const button = event.target.closest(paginationSelector);
    if (!button || button.classList.contains('boost-sd__pagination-number--active')) return;

    const requestedPage = getRequestedPage(button);
    if (!requestedPage) return;

    const observer = new MutationObserver(function() {
      const activePage = document.querySelector(activePageSelector);

      if (!activePage || Number(activePage.textContent.trim()) !== requestedPage) return;

      observer.disconnect();
      requestAnimationFrame(function() {
        requestAnimationFrame(scrollToCollectionGrid);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function() { observer.disconnect(); }, 5000);
  }, true);
})();

document.addEventListener('DOMContentLoaded', setAnchorTarget);
